module.exports = __webpack_public_path__ + "static/img/cont57 (2).e5219d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont57 (2).jpg
// module id = wZ/j
// module chunks = 0